// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bidding-agent-card[data-v-5677d7da]{border:1px solid #e0e0e0;border-radius:6px}[data-v-5677d7da] .v-expansion-panel-header{padding-left:16px;padding-right:16px}[data-v-5677d7da] .v-expansion-panel-content__wrap{padding-left:16px;padding-right:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
